import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-pd': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119.1 0 256 0 393 111 504 248 504S496 393 496 256C496 119.1 385 8 248 8zM248 457.5C108.8 457.5 12.2 319.5 57.8 189.6L136.6 224.7C134.5 235.2 133.3 246.2 133.3 257.6 133.3 356.6 207.2 384.5 253.7 384.5 276.6 384.5 307.2 377.8 333.1 355L297 311.1C291.5 317.4 279.4 327.8 260.7 327.8 222.9 327.8 207 287.9 206.8 255.9 437.2 358.5 423.3 352.4 424.7 352.7 390.4 415.1 324.1 457.5 248 457.5zM442.2 307.5L218.2 207.5C237 173.5 273.1 176.8 292.9 196.5L333.3 154.9C306.2 131.6 275.3 127.4 255.2 127.4 207.8 127.4 174.3 147.9 154.5 179L79.6 145.6C115.7 90.7 177.7 54.4 248.1 54.4 359.2 54.4 449.6 144.8 449.6 255.9 449.6 273.9 447.2 291.3 442.8 307.9 442.5 307.8 442.4 307.7 442.2 307.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-pd.js
// module id = aSjK
// module chunks = 144